<template>
    <div>
        <h1 style="font-size: 24px; color: black;">常量配置</h1>
        <el-row>
            <el-col>
                <el-button type="primary" @click="showAddConstantConfigFormDialog('添加配置')">添加配置</el-button>
            </el-col>
        </el-row>
        <el-col :span="5">
            <span> 渠道： </span>
            <el-cascader v-model="queryData.subChannels" :options="channelList" :props="optionProps" clearable
                         collapse-tags>
            </el-cascader>
        </el-col>
        <el-button type="primary" @click="search">查询</el-button>
        <h1>
            <el-table border :data="list">
                <el-table-column prop="id" label="编号ID" align="center"></el-table-column>
                <el-table-column prop="k" label="K值" align="center"></el-table-column>
                <el-table-column prop="v" label="V值" align="center"></el-table-column>
                <el-table-column prop="versionCodeMin" label="大于等于versionCode" align="center"></el-table-column>
                <el-table-column prop="versionCodeMax" label="小于等于versionCode" align="center"></el-table-column>
                <el-table-column label="关联渠道" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.subChannelName.length === 0 ? " " : scope.row.subChannelName.join(" , ") }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showAddConstantConfigFormDialog('编辑配置',scope.row)">编辑
                        </el-button>
                        <el-button type="text" @click="removeConstantConfig(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </h1>

        <el-dialog :title="dialogConstantConfigTitle" center :visible.sync="dialogConstantConfigVisible" width="800px">
            <el-form :model="addConstantConfigForm">
                <el-form-item label="规则K值 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addConstantConfigForm.k"></el-input>
                </el-form-item>
                <el-form-item label="规则V值 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addConstantConfigForm.v"></el-input>
                </el-form-item>
                <el-form-item label="备注 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addConstantConfigForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="大于等于versionCode :" :label-width="labelWidth">
                    <el-input type="text" v-model="addConstantConfigForm.versionCodeMin"></el-input>
                </el-form-item>
                <el-form-item label="小于等于versionCode :" :label-width="labelWidth">
                    <el-input type="text" v-model="addConstantConfigForm.versionCodeMax"></el-input>
                </el-form-item>
                <el-form-item label="渠道筛选 :" :label-width="labelWidth">
                    <el-cascader v-model="addConstantConfigForm.subChannel" :options="channelList" :props="optionProps"
                                 clearable collapse-tags>
                    </el-cascader>
                </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmConstantConfigForm">提 交</el-button>
                <el-button type="info" @click="dialogConstantConfigVisible=false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {channelList, deleteConstantConfig, saveConstantConfig, searchConstantConfig} from '@/http/api'

export default {
    name: "ConstantConfig",
    data() {
        return {
            dialogConstantConfigVisible: false,
            dialogConstantConfigTitle: '',
            labelWidth: '110px',
            list: [],
            channelList: [],
            optionProps: {
                emitPath: false,
                multiple: true,
                value: 'subChannel',
                label: 'name',
                children: 'children',
            },
            addConstantConfigForm: {
                id: 0,
                k: '',
                v: '',
                remark: '',
                versionCodeMin: 0,
                versionCodeMax: 9999,
                subChannel: [],
            },
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
            queryData: {
                subChannels: []
            },
        }
    },
    methods: {
        handleSizeChange(size) {
            this.page.size = size;
            this.search();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.search();
        },
        search() {
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            searchConstantConfig(this.queryData).then(resp => {
                this.list = resp.data.info.list;
                this.page.totalElements = resp.data.info.totalElements;
            });
        },
        removeConstantConfig(id) {
            this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteConstantConfig(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.search();
                    }
                });
            }).catch(() => {
            })
        },
        showAddConstantConfigFormDialog(_title, _data) {
            this.dialogConstantConfigVisible = true;
            this.dialogConstantConfigTitle = _title;
            this.addConstantConfigForm = {
                id: 0,
                k: '',
                v: '',
                remark: '',
                versionCodeMin: 0,
                versionCodeMax: 9999,
                subChannel: []
            };
            if (_data) {
                this.addConstantConfigForm = {
                    id: _data.id,
                    k: _data.k,
                    v: _data.v,
                    remark: _data.remark,
                    versionCodeMin: _data.versionCodeMin,
                    versionCodeMax: _data.versionCodeMax,
                    subChannel: _data.subChannelIds
                }
            }
        },
        confirmConstantConfigForm() {
            let _message = '';
            if (this.addConstantConfigForm.k === '') {
                _message = '请输入k值'
            } else if (this.addConstantConfigForm.subChannel.length < 1) {
                _message = '请选择相关渠道'
            } else if (this.addConstantConfigForm.remark === '') {
                _message = '请填写备注，以防忘记配置内容'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            saveConstantConfig(this.addConstantConfigForm).then(resp => {
                if (resp.data.status === 0) {
                    this.search();
                    this.dialogConstantConfigVisible = false;
                }
            });
        }

    },
    created() {
        this.search();
        let _this = this;
        channelList().then(resp => {
            this.channelList = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                if (channel.children) {
                    channel.children = channel.children.filter(sub => sub.state === 1)
                }
                return channel;
            }).filter(channel => channel.children && channel.children.length);
            this.channelList.forEach(function (channel) {
                _this.$set(channel, 'subChannel', channel.id);
            });
        });
    }
}
</script>

<style scoped>

</style>